import Filter from './Filter'

export default class ResearchAdvisor extends Filter {
    filterComponent = import('@/views/components/filters/compoents/ResearchAdvisorFilterComponent.vue')

    static ORGANIZATION = 'organization'

    fields = {
      [ResearchAdvisor.ORGANIZATION]: {
        label: 'Organization',
      },
    }
}
